import httpService from "./httpService";
import utils from "./utils";

export default {
  findAll(form, pageable) {
    let params = utils.merge(form);
    params = utils.merge(params, pageable);
    return httpService.get("/vShareLibrary/findAll", {params: params});
  },
};



// WEBPACK FOOTER //
// ./src/services/vShareLibService.js